<div class="header">
  <div class="title">Dataset Update</div>
</div>
<div id="data-update-content">
  <div *ngIf="true" id="update-list-container">
    <div class="table-title">
      <span>Data Files</span>
    </div>
    <div class="table-wrapper">
      <table
        id="update-list-table"
        mat-table
        *ngIf="updated_data_list && updated_data_list.length > 0"
        [dataSource]="dataSource"
        class="my-table"
      >
        <ng-container matColumnDef="sNo">
          <th
            style="width: 15%; padding-left: 2vw"
            mat-header-cell
            *matHeaderCellDef
            class="flex-1"
          >
            <mat-label>S.No</mat-label>
          </th>
          <td
            style="padding-left: 2vw"
            mat-cell
            *matCellDef="let planogram; let i = index"
            class="flex-1"
          >
            {{ i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fileName">
          <th
            style="width: 25%"
            mat-header-cell
            *matHeaderCellDef
            class="flex-1"
          >
            <mat-label>File Name</mat-label>
          </th>
          <td mat-cell *matCellDef="let planogram" class="flex-1">
            {{ planogram.fileName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lastModified">
          <th
            style="width: 20%"
            mat-header-cell
            *matHeaderCellDef
            class="flex-1"
          >
            <mat-label>Last Modified</mat-label>
          </th>
          <td mat-cell *matCellDef="let planogram" class="flex-1">
            {{ planogram.lastModified | date : "dd/MM/yyyy | hh:mm a" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th
            style="text-align: center; width: 30%"
            mat-header-cell
            *matHeaderCellDef
            class="flex-2"
          >
            <mat-label>Action</mat-label>
          </th>
          <td mat-cell *matCellDef="let planogramItem" class="flex-2">
            <div class="action-group">
              <div
                (click)="handleUploadClick(planogramItem.dataName)"
                class="upload-action"
              >
                <img src="../../assets/upload.svg" alt="upload" />
                <span>Upload |</span>
                <input
                  #fileInput
                  type="file"
                  (change)="uploadCsv($event)"
                  accept=".csv"
                  style="display: none"
                />
              </div>
              <div
                (click)="handleDownloadClick($event, planogramItem.dataName)"
                class="download-action"
              >
                <img src="../../assets/download.svg" alt="download" />
                <span>Download |</span>
              </div>
              <div
                (click)="handlePreviewClick($event, planogramItem.dataName)"
                class="preview-action"
              >
                <img src="../../assets/preview.svg" alt="preview" />
                <span>Preview</span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div class="no-data-message" *ngIf="updated_data_list.length == 0">
        No data matching with the filter
      </div>
    </div>
  </div>
  <div
    style="width: 100%; height: 100%; margin-top: 3%"
    class="data-notes-wrapper"
  >
    <div class="card">
      <div>
        <div style="margin-bottom: 3%">
          <div class="data-notes-title">
            <div>Notes for updating the data</div>
          </div>
          <!-- <span class="info-label"
            >Ergonomic executive chair upholstered in bonded black leather
            all-day comfort and support</span
          > -->
        </div>
        <div class="horizontal-line"></div>
        <div style="height: 35vh; overflow-y: scroll">
          <div class="data-notes-cards">
            <ng-container *ngFor="let note of dataNotes; let i = index">
              <div class="-data-notes-list">
                <div class="notes-lists">
                  <div class="list-details">
                    <div class="notes-star-img">
                      <img src="../../assets/notes_star.svg" alt="Star" />
                      <span>{{ note.heading }}</span>
                    </div>
                    <div>
                      <div class="list-info">
                        <div *ngFor="let s of splitSentences(note.description)">{{s}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="i !== dataNotes.length - 1"
                  class="horizontal-line"
                ></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loader
    [is_show_loader]="(loader | async)! || is_show_loader"
  ></app-loader>
</div>
